import React, { useMemo } from 'react'
import { IonCard } from '@ionic/react'
import ImagePlaceholder from '../placeholders/Image'

import classNames from 'classnames'
import './styles.less'
import { ItemFavouriteButton } from '../favourite/ItemFavouriteButton'
import { useLiveQuery } from 'dexie-react-hooks'
import db from 'mobile_web/modules/db'
import { addToFavouritedKeys, collectionItemToFavouritedItem, removeFromFavouritedKeys } from 'mobile_web/modules/favourites/queries'
import { AppMetaData, CollectionItem, RootStoreState } from 'mytours-read-common'
import { useSelector } from 'react-redux'

interface Props extends React.ComponentProps<typeof IonCard> {
	label?: React.ReactNode
	image?: string
	image2x?: string
	alt?: string
	loading?: boolean
	itemId: number
	itemType: string
	item: CollectionItem
	toggleFavorite: React.MouseEventHandler<HTMLDivElement>
	isFavourited: boolean
	appMetaData: AppMetaData
}

const CardImage: React.FC<Props> = ({ label, image, image2x, alt, style, className, loading, itemId, itemType, ...props }) => {
	const newStyle = useMemo(() => ({ ...style, image }), [style, image])

	const labelNode = useMemo(() => {
		switch (typeof label) {
			case 'number':
			case 'string': {
				return (
					<div className="card-image-label">
						<p>{label}</p>
					</div>
				)
			}
			case 'undefined': {
				return null
			}
			default: {
				return (
					<div className="card-image-label card-image-label-container">
						<p>{label}</p>
					</div>
				)
			}
		}
	}, [label])

	if (loading) {
		return <ImagePlaceholder {...props} className={classNames('card-image placeholder', className)} style={newStyle} />
	}

	const extraProps = image2x ? { srcSet: `${image2x} 2x` } : {}

	return (
		<IonCard {...props} className={classNames('card-image', className)} style={newStyle}>
			<ItemFavouriteButton onClick={props.toggleFavorite} isFavourited={props.isFavourited} favoritesEnabled={props.appMetaData.favorites_enabled} />
			<img className="card-inner-image" src={image} {...extraProps} alt={alt || ''} />
			{labelNode}
		</IonCard>
	)
}

export default CardImage
